module.exports = __webpack_public_path__ + "img/woman.18887ab8.png";